import { Grid, Toolbar, Typography, styled } from "@mui/material";
import React, { FunctionComponent } from "react";
import ControlSectionDivider from "./ControlSectionDivider";

const DrawerItem = styled(Grid)(({ theme }) => ({
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px",
}));

const DrawerHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.info.main,
}));

const DrawerSection = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

interface OwnProps {
    sectionTitle: string;
    sectionContent: React.ReactNode;
    titleClassName?: string;
    contentClassName?: string;

    // if true; hides entire section, both title and content will not be rendered
    hideSection?: boolean;
    // if true; show divider below content; should be true for all but last section in side-content
    showDivider?: boolean;
}

type Props = OwnProps;

const ControlsSection: FunctionComponent<React.PropsWithChildren<Props>> = (
    props,
) => {
    return (
        <>
            {props.sectionContent && !props.hideSection && (
                <>
                    <Toolbar>
                        <DrawerHeader
                            className={props.titleClassName}
                            variant={"h5"}
                        >
                            {props.sectionTitle}
                        </DrawerHeader>
                    </Toolbar>
                    <DrawerSection
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="center"
                        className={props.contentClassName}
                    >
                        <DrawerItem item xs>
                            {props.sectionContent}
                        </DrawerItem>
                    </DrawerSection>
                    {props.showDivider && <ControlSectionDivider />}
                </>
            )}
        </>
    );
};

export default ControlsSection;
